export default "__VITE_ASSET__jNJG6Bha__"